import { Schema } from "prosemirror-model";
const pmSchemaJson = {
    topNode: "doc",
    nodes: {
        paragraph: {
            content: "inline*",
            group: "block",
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.rich-text",
                },
                variantId: {
                    default: "default",
                },
            },
            parseDOM: [
                {
                    tag: "p",
                },
            ],
        },
        reactComponent: {
            group: "block",
            atom: true,
            draggable: true,
            attrs: {
                count: {
                    default: 0,
                },
            },
            parseDOM: [
                {
                    tag: "react-component",
                },
            ],
        },
        tableRow: {
            tableRole: "row",
            content: "(tableCell | tableHeader)*",
            parseDOM: [
                {
                    tag: "tr",
                },
            ],
        },
        table: {
            tableRole: "table",
            content: "tableRow+",
            group: "defaultTable",
            isolating: true,
            parseDOM: [
                {
                    tag: "table",
                },
            ],
        },
        tableCell: {
            tableRole: "cell",
            content: "(paragraph|image)+",
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
                textAlign: {
                    default: "left",
                },
                colspan: {
                    default: 1,
                },
                rowspan: {
                    default: 1,
                },
                colwidth: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "td",
                },
            ],
        },
        tableHeader: {
            tableRole: "header_cell",
            content: "(paragraph|image)+",
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
                textAlign: {
                    default: "left",
                },
                colspan: {
                    default: 1,
                },
                rowspan: {
                    default: 1,
                },
                colwidth: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "th",
                },
            ],
        },
        tableContainer: {
            content: "table",
            group: "block",
            atom: true,
            draggable: false,
            defining: true,
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.table",
                },
                variantId: {
                    default: "default",
                },
                hasBorder: {
                    default: true,
                },
            },
            parseDOM: [
                {
                    tag: "tableContainer",
                },
            ],
        },
        hardBreak: {
            group: "inline",
            inline: true,
            selectable: false,
            parseDOM: [
                {
                    tag: "br",
                },
            ],
        },
        text: {
            group: "inline",
        },
        heading: {
            content: "inline*",
            group: "block",
            defining: true,
            attrs: {
                id: {
                    default: null,
                },
                level: {
                    default: 1,
                },
                definitionId: {
                    default: null,
                },
                variantId: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1,
                        definitionId: "io.supernova.block.title1",
                        variantId: "default",
                    },
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2,
                        definitionId: "io.supernova.block.title2",
                        variantId: "default",
                    },
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3,
                        definitionId: "io.supernova.block.title3",
                        variantId: "default",
                    },
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4,
                        definitionId: "io.supernova.block.title4",
                        variantId: "default",
                    },
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5,
                        definitionId: "io.supernova.block.title5",
                        variantId: "default",
                    },
                },
            ],
        },
        listItem: {
            content: "paragraph list{0,1}",
            defining: true,
            attrs: {
                id: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "li",
                },
            ],
        },
        orderedList: {
            content: "listItem+",
            group: "block list",
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.ordered-list",
                },
                variantId: {
                    default: "default",
                },
                start: {
                    default: 1,
                },
            },
            parseDOM: [
                {
                    tag: "ol",
                },
            ],
        },
        bulletList: {
            content: "listItem+",
            group: "block list",
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.unordered-list",
                },
                variantId: {
                    default: "default",
                },
            },
            parseDOM: [
                {
                    tag: "ul",
                },
            ],
        },
        horizontalRule: {
            group: "block",
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.divider",
                },
                variantId: {
                    default: "default",
                },
            },
            parseDOM: [
                {
                    tag: "div.node-horizontalRule",
                },
                {
                    tag: "hr",
                },
            ],
        },
        blockquote: {
            content: "inline*",
            group: "block",
            draggable: true,
            defining: true,
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.blockquote",
                },
                variantId: {
                    default: "default",
                },
            },
            parseDOM: [
                {
                    tag: "blockquote",
                },
            ],
        },
        plainSection: {
            content: "sectionItem",
            group: "section",
            atom: true,
            draggable: false,
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "section",
                    attrs: {
                        "data-section-type": "plain",
                    },
                },
            ],
        },
        tabsSection: {
            content: "sectionItem+",
            group: "section",
            atom: true,
            draggable: false,
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
                variantId: {
                    default: "Tabs",
                },
            },
            parseDOM: [
                {
                    tag: "div",
                },
            ],
        },
        sectionItem: {
            content: "sectionItemColumn{1, 3}",
            group: "sectionItem",
            atom: true,
            selectable: false,
            draggable: false,
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
                title: {
                    default: "",
                },
            },
            parseDOM: [
                {
                    tag: "section-item",
                },
            ],
        },
        sectionItemColumn: {
            content: "block+",
            group: "sectionItemColumn",
            atom: true,
            selectable: false,
            draggable: false,
            isolating: true,
            attrs: {
                id: {
                    default: null,
                },
            },
            parseDOM: [
                {
                    tag: "section-item-column",
                },
            ],
        },
        doc: {
            content: "(block|section)+",
        },
        callout: {
            content: "inline*",
            group: "block",
            draggable: true,
            defining: true,
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: "io.supernova.block.callout",
                },
                variantId: {
                    default: "default",
                },
                type: {
                    default: "neutral",
                },
            },
            parseDOM: [
                {
                    tag: "callout",
                },
            ],
        },
        image: {
            group: "block customBlock",
            atom: true,
            draggable: false,
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: null,
                },
                variantId: {
                    default: null,
                },
                appearance: {
                    default: "{}",
                },
                columns: {
                    default: 1,
                },
                items: {
                    default: "[]",
                },
            },
            parseDOM: [
                {
                    tag: "block-node",
                },
            ],
        },
        blockNode: {
            group: "block customBlock",
            atom: true,
            draggable: false,
            attrs: {
                id: {
                    default: null,
                },
                definitionId: {
                    default: null,
                },
                variantId: {
                    default: null,
                },
                appearance: {
                    default: "{}",
                },
                columns: {
                    default: 1,
                },
                items: {
                    default: "[]",
                },
            },
            parseDOM: [
                {
                    tag: "block-node",
                },
            ],
        },
    },
    marks: {
        link: {
            inclusive: false,
            attrs: {
                href: {
                    default: null,
                },
                target: {
                    default: "_blank",
                },
                rel: {
                    default: "noopener noreferrer nofollow",
                },
                class: {
                    default: "tiptap-link",
                },
            },
            parseDOM: [
                {
                    tag: 'a[href]:not([href *= "javascript:" i])',
                },
            ],
        },
        commentHighlight: {
            attrs: {
                highlightId: {
                    default: null,
                },
                resolved: {
                    default: false,
                },
            },
            parseDOM: [
                {
                    tag: "commenthighlight",
                },
            ],
        },
        bold: {
            parseDOM: [
                {
                    tag: "strong",
                },
                {
                    tag: "b",
                },
                {
                    style: "font-weight",
                },
            ],
        },
        italic: {
            parseDOM: [
                {
                    tag: "em",
                },
                {
                    tag: "i",
                },
                {
                    style: "font-style=italic",
                },
            ],
        },
        strike: {
            parseDOM: [
                {
                    tag: "s",
                },
                {
                    tag: "del",
                },
                {
                    tag: "strike",
                },
                {
                    style: "text-decoration",
                    consuming: false,
                },
            ],
        },
        code: {
            excludes: "bold code italic strike link",
            code: true,
            parseDOM: [
                {
                    tag: "code",
                },
            ],
        },
    },
};
export const mainEditorProsemirrorSchema = new Schema(pmSchemaJson);
